/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { CustomLink } from "../custom-link";
import { ImageFallback } from "../basic/image-fallback";
import "./header-helper-components.m.css";

export const getMenuData = (menu, menuGroup, domainSlug) => {
  const filteredMenu = domainSlug
    ? menu.filter(item => item["menu-group-slug"] === `header-menu-${domainSlug}`)
    : menu.filter(item => item["menu-group-slug"] === menuGroup);
  if (menuGroup === "sidebar-menu") {
    if (domainSlug) return getMenuData(menu, `sidebar-menu-${domainSlug}`);
    if (filteredMenu.length === 0) return getMenuData(menu, "default");
  }
  return filteredMenu;
};

export const CtaWrapper = props => {
  const { customCssClasses = "", isSingleLayer, enableAccesstype, localizedElementsData } = props;
  const { subscribe: localizedSubscribe } = localizedElementsData;

  const headerClass = isSingleLayer ? "single-layer-header" : "header";
  const cssClasses = [headerClass, customCssClasses].join(" ");
  return (
    <>
      {enableAccesstype && (
        <CustomLink className={cssClasses} href="/subscription" data-test-id="header-subscribe">
          {localizedSubscribe || "Subscribe"}
        </CustomLink>
      )}
      <div id="header-social-follow" />
    </>
  );
};
CtaWrapper.propTypes = {
  customCssClasses: PropTypes.string,
  isSingleLayer: PropTypes.bool,
  enableAccesstype: PropTypes.bool,
  localizedElementsData: PropTypes.shape({
    subscribe: PropTypes.string
  })
};

export const LogoWrapper = props => {
  // Setting sketchesHost as the logo handler for now for LogoWrapper and Monogram and Footer.
  // Once subdomain changes are also in place, we may need to check this
  // how this going to playout.
  const logoUrl = useSelector(state =>
    get(state, ["qt", "config", "theme-attributes", "logo_url"], get(state, ["qt", "config", "sketches-host"], "/"))
  );
  return (
    <div className="logo-wrapper">
      <CustomLink
        href={logoUrl}
        callback={() => {
          props.closeAll();
          typeof props.windowScroll === "function" && props.windowScroll();
        }}
      >
        {props.headerSecondaryLogo ? (
          <img data-test-id="secondary_logo" src={props.headerSecondaryLogo} alt="Logo" loading="lazy" />
        ) : (
          <ImageFallback />
        )}
      </CustomLink>
    </div>
  );
};
LogoWrapper.propTypes = {
  windowScroll: PropTypes.func,
  closeAll: PropTypes.func,
  headerSecondaryLogo: PropTypes.string
};
